module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-200.530dd7fa.eot";